export var LockStatus;
(function (LockStatus) {
    LockStatus[LockStatus["Empty"] = 0] = "Empty";
    LockStatus[LockStatus["Pending"] = 1] = "Pending";
    LockStatus[LockStatus["Refunded"] = 2] = "Refunded";
    LockStatus[LockStatus["Redeemed"] = 3] = "Redeemed";
})(LockStatus || (LockStatus = {}));
export var TransactionStatus;
(function (TransactionStatus) {
    TransactionStatus["Pending"] = "pending";
    TransactionStatus["Confirmed"] = "confirmed";
    TransactionStatus["Failed"] = "failed";
})(TransactionStatus || (TransactionStatus = {}));
